import type * as lazyIndex from './lazyIndex';
import type { PriorityViewBarProps } from './components/PriorityViewBar';
import type { PriorityViewHeaderButtonProps } from './components/PriorityViewHeaderButtons';
import type { PrioritizeStatusBarProps } from './components/PrioritizeStatusBar';
import { createLazyComponent, type LazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PriorityInbox"*/ './lazyIndex'),
    { name: 'PriorityInbox' }
);

export const PriorityViewBar: LazyComponent<PriorityViewBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PriorityViewBar);

export const PriorityViewHeaderButtons: LazyComponent<
    PriorityViewHeaderButtonProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.PriorityViewHeaderButtons);

export const PrioritizeStatusBar: LazyComponent<PrioritizeStatusBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PrioritizeStatusBar);

export { shouldShowPrioritizeButton } from './utils/shouldShowPrioritizeButton';
export { shouldUseCustomHighPriorityView } from './utils/shouldUseCustomHighPriorityView';

export const lazyClosePriorityView: LazyAction<
    typeof lazyIndex.closePriorityView,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.closePriorityView);

export const lazyStartPrioritize: LazyAction<typeof lazyIndex.startPrioritize, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.startPrioritize);
